import {Pipe, PipeTransform} from '@angular/core';
import {IGetCategoriesItemDto} from 'app/main/pages/categories.dto';
import {IDocumentTypesDto} from 'app/main/pages/documents/dto/document-listing.dto';
import { DocumentTypeSectionEnum } from 'app/main/pages/settings/documenttype/document-type-settings-modal/default-constants/document-type-settings.constants';
import { CategoryFacade } from 'app/store/category.facade';
import { filter, map, Observable, take } from 'rxjs';

@Pipe({
  name: 'documentTypeAllowedCategories'
})
export class DocumentTypeAllowedCategoriesPipe implements PipeTransform {


  constructor(private _categoryFacade: CategoryFacade) {}

  
  transform(categories: IGetCategoriesItemDto[]) {
    return this.flattenCategories(categories);
  }



  flattenCategories(nodes: IGetCategoriesItemDto[], level: number = 0): IGetCategoriesItemDto[] {
    let result: IGetCategoriesItemDto[] = [];
    for (const node of nodes) {
      const currentLevel = (node.parent_category === 0 || !node.id) ? 0 : level;
      const flatNode: IGetCategoriesItemDto = { ...node, level: currentLevel };
      result.push(flatNode);
      if (node.children?.length) {
        result = result.concat(this.flattenCategories(node.children, currentLevel + 1));
      }
    }
    return result;
  }
}
